import MapImg from '@/assets/img/MAP.png';
import { Feature } from '@/services/mapbox';
import * as React from 'react';
import './index.scss';
import { Input } from './Input';
import { Map } from './Map';

export interface MainComponentProps {
  options: Feature[];
  onOptionsChange: (o: Feature[]) => void;
  value: Feature | null;
  onValueChange: (o: Feature | null) => void;
  onInputValueChange: (value: string) => void;
  inputError: boolean;
}

export const MainComponent: React.FC<MainComponentProps> = ({
  options,
  onOptionsChange,
  value,
  onValueChange,
  onInputValueChange,
  inputError,
}) => {
  return (
    <div className="Main">
      <div className="Main__content">
        <p className="Main__content__text">
          Il TrovaCollegio a cura di YouTrend ti permette di scoprire tutti i
          candidati del tuo collegio, i risultati delle elezioni precedenti e le
          principali statistiche sociali ed economiche
        </p>
        <Input
          options={options}
          onOptionsChange={onOptionsChange}
          value={value}
          onValueChange={onValueChange}
          onInputValueChange={onInputValueChange}
          isError={inputError}
        />
      </div>

      <div
        className="Main__MapImg"
        style={{
          backgroundImage: `url(${MapImg})`,
          minHeight: '600px',
          backgroundRepeat: 'repeat',
          backgroundPosition: 'center',
          backgroundPositionY: 'initial',
        }}
      />

      <p className="Main__mapbox_information">
        © <a href="https://www.mapbox.com/about/maps/">Mapbox</a> ©{' '}
        <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>{' '}
        <strong>
          <a href="https://www.mapbox.com/map-feedback/" target="_blank">
            Improve this map
          </a>
        </strong>
      </p>
    </div>
  );
};
